import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '../components/error-boundary';
import { PageContainer } from '../components/layout/page-container';
import { GatePrompt, useActionGate } from '../features/auth/action-gate';
import { PostEditor } from '../features/community/post-editor';
import { usePost } from '../features/community/use-posts';

export const Route = createFileRoute('/posts/$id/edit')({
  // 로그인 화면 — 세션이 브라우저에만 있다. 서버는 레이아웃만 그린다(docs/SSR.md).
  ssr: false,
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const gate = useActionGate();
  if (gate === 'anonymous' || gate === 'loading') {
    return <PageContainer><GatePrompt status={gate} message="글을 고치려면 로그인이 필요해요." /></PageContainer>;
  }
  return (
    <PageContainer>
      <h1 className="sr-only">글 수정</h1>
      <ErrorBoundary resetKey={id} fallback={() => <p className="text-sm text-text-muted">글을 찾을 수 없어요.</p>}>
        <Suspense fallback={<p className="text-sm text-text-muted">불러오는 중…</p>}>
          <Loader id={id} />
        </Suspense>
      </ErrorBoundary>
    </PageContainer>
  );
}

function Loader({ id }: { id: string }) {
  const { data: post } = usePost(id);
  return <PostEditor post={post} />;
}
